import Vue from 'vue';
import VueRouter from 'vue-router';
import Assessment from '../views/Assessment.vue';
import Home from '../views/Home.vue';
import AdHocCommunity from '../views/AdHocCommunity.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/community/:community_id/assessment',
    name: 'assessment',
    component: Assessment,
  },
  {
    path: '/login',
    name: 'LogIn',
    component: () => import(/* webpackChunkName: "login" */ '../views/LogIn.vue'),
  },
  {
    path: '/ad-hoc-community',
    name: 'AdHocCommunity',
    component: AdHocCommunity,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
